document.addEventListener('DOMContentLoaded', function () {
  // 共通の変数定義
  const floorButtons = document.querySelectorAll('.floor-select');
  const maps = document.querySelectorAll('.map');
  const mapsvg = document.querySelector('.mapsvg');
  const hoverBoxes = document.querySelectorAll('.hover-box');
  let currentBubble = null;

  // 必要な要素が存在するかチェック
  if (floorButtons.length === 0 || maps.length === 0) return;

  // ハッシュからフロアを取得する関数
  const getFloorFromHash = () => {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return 'B1F';

    // 数値のみの場合
    if (!isNaN(hash)) {
      return `${hash}F`;
    }

    // B1などの場合
    if (hash.toUpperCase().startsWith('B')) {
      return `${hash.toUpperCase()}F`;
    }

    // すでにF付きの場合
    if (hash.toUpperCase().endsWith('F')) {
      return hash.toUpperCase();
    }

    return `${hash.toUpperCase()}F`;
  };

  // フロア切り替えの処理
  const switchFloor = (targetFloor) => {
    const targetButton = document.querySelector(`[data-floor="${targetFloor}"]`);
    const targetMap = document.querySelector(`.map._${targetFloor.toLowerCase()}`);

    if (!targetButton || !targetMap) return;

    // ボタンの切り替え
    floorButtons.forEach(btn => btn.classList.remove('current'));
    targetButton.classList.add('current');

    // 新しいマップを表示する前に、トランジションが終わるのを待つ
    maps.forEach(map => {
      if (map !== targetMap) {
        map.classList.remove('is-current');
      }
    });

    // 少し遅延させて新しいマップを表示
    requestAnimationFrame(() => {
      targetMap.classList.add('is-current');
    });
  };

  // フロアボタンのイベント設定
  floorButtons.forEach(button => {
    button.addEventListener('click', function () {
      const targetFloor = this.getAttribute('data-floor');
      switchFloor(targetFloor);
      window.location.hash = targetFloor.replace('F', '');
    });
  });

  // ハッシュ変更イベント
  window.addEventListener('hashchange', () => {
    const floor = getFloorFromHash();
    switchFloor(floor);
  });

  // 吹き出し関連の処理
  const bubbleOffsets = {
    //'bubble1': { x: -35, y: 0 },  // bubble1を右に20px移動
  };

  // デバイス判定
  const isTouchDevice = ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);

  function updateBubblePosition(box, bubble) {
    const boxRect = box.getBoundingClientRect();
    const svgRect = mapsvg.getBoundingClientRect();
    const bubbleRect = bubble.getBoundingClientRect();
    const offset = bubbleOffsets[bubble.id] || { x: 0, y: 0 };

    // X座標: boxの中心
    const centerX = boxRect.left + (boxRect.width / 2) - svgRect.left + offset.x;
    // Y座標: boxの上端 + boxの高さの半分 - 吹き出しの高さ
    const centerY = (boxRect.top - svgRect.top) - (bubbleRect.height * 1 / 1.15) + offset.y;

    bubble.style.left = `${centerX}px`;
    bubble.style.top = `${centerY}px`;
  }

  function hideAllBubbles() {
    hoverBoxes.forEach(box => {
      const bubbleId = box.dataset.bubble;
      const bubble = document.getElementById(bubbleId);
      if (bubble) {
        bubble.classList.remove('is-active');
      }
    });
    currentBubble = null;
  }

  // 吹き出しのイベント設定
  hoverBoxes.forEach(box => {
    const bubbleId = box.dataset.bubble;
    const bubble = document.getElementById(bubbleId);

    if (!isTouchDevice) {
      // PCの場合のホバーイベント
      box.addEventListener('mouseenter', function () {
        hideAllBubbles();
        updateBubblePosition(box, bubble);
        bubble.classList.add('is-active');
        currentBubble = bubble;
      });

      box.addEventListener('mouseleave', function (e) {
        const relatedTarget = e.relatedTarget;
        if (!relatedTarget || !bubble.contains(relatedTarget)) {
          hideAllBubbles();
        }
      });

      if (bubble) {
        bubble.addEventListener('mouseleave', function (e) {
          const relatedTarget = e.relatedTarget;
          if (!relatedTarget || !box.contains(relatedTarget)) {
            hideAllBubbles();
          }
        });
      }
    } else {
      // タッチデバイスの場合のクリックイベント
      box.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (currentBubble === bubble) {
          hideAllBubbles();
        } else {
          hideAllBubbles();
          updateBubblePosition(box, bubble);
          bubble.classList.add('is-active');
          currentBubble = bubble;
        }
      });
    }
  });

  // マップ領域クリックイベント（タッチデバイスのみ）
  if (isTouchDevice) {
    mapsvg.addEventListener('click', function (e) {
      if (!e.target.closest('.hover-box')) {
        hideAllBubbles();
      }
    });
  }

  // リサイズイベント
  window.addEventListener('resize', function () {
    if (currentBubble) {
      const box = document.querySelector(`[data-bubble="${currentBubble.id}"]`);
      updateBubblePosition(box, currentBubble);
    }
  });

  // 初期表示（URLのハッシュを確認）
  const initialFloor = getFloorFromHash();
  console.log('Initial hash:', window.location.hash);
  console.log('Initial floor:', initialFloor);
  console.log('Target button:', document.querySelector(`[data-floor="${initialFloor}"]`));
  console.log('Target map:', document.querySelector(`.map._${initialFloor.toLowerCase()}`));
  switchFloor(initialFloor);
});
